import React from 'react'
import './Subtotal.css'
import { useHistory } from "react-router-dom";
import CurrencyFormat from 'react-currency-format'
import { useStateValue } from "./Context";
import { getBasketTotal } from "./reducer";


export default function Subtotal() {
  const [{basket}, dispatch] = useStateValue()

  const history=  useHistory()

  return (
    <div  className='subtotal'>
            <CurrencyFormat
        renderText={(value) => (
          <>
            <p>
              {/* Part of the homework */}
              Subtotal ({basket.length} items): <strong>{value}</strong>
            </p>
            <small className="subtotal_gift">
              <input type="checkbox" /> This order contains a gift
            </small>
          </>
        )}
        decimalScale={2}
        value= {getBasketTotal(basket)}  // Part of the homework
        displayType={"text"}
        thousandSeparator={true}
        prefix={"₹"}
      />
   <button onClick={e => history.push('/payment')} >Proceed to Checkout</button>
    </div>
  )
}
